import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import css from './FieldInstructions.module.css';

const FieldInstructions = ({ className, rootClassName, children }) => {
  const classes = classNames(rootClassName || css.root, className);

  return <p className={classes}>{children}</p>;
};

FieldInstructions.defaultProps = {
  className: null,
  rootClassName: null,
};

FieldInstructions.propTypes = {
  className: string,
  rootClassName: string,
};

export default FieldInstructions;
